import { useEffect } from 'preact/hooks';
import { loadFonts, appendScript } from '@/utils';
import { useConfigStore, useFormProps } from '../stores/ConfigStore';

export default function Assets() {
	const { fontsDomain } = useFormProps();
	const { properties, webFonts } = useConfigStore();
	const blockWebFonts = properties.advanced?.block_webfont_loading;

	useEffect(() => {
		if (!blockWebFonts) {
			loadFonts(webFonts, fontsDomain);
		}

		Object.keys(properties?.advanced?.customLibraries ?? {})
			.map(key => properties?.advanced?.customLibraries[key] ?? {})
			.forEach(script => appendScript(script.url));
	}, []);

	return null;
}
